import React, { useState } from "react";
import BC365Service from "../../../../services/beautyclub365";
import { useCookies } from 'react-cookie';
import { useUserContext } from "../../../../context/UserContext";
import { validateRegister, validateAuth } from "../../../../shared/validations";
import { usePopupContext } from "../../../../context/PopupContext";
import AllProducts from "../../../Forms/AllProducts/AllProducts";
import WaitingTrialAnswer from "../../../Forms/WaitingTrialAnswer/WaitingTrialAnswer";
import TrialBadAnswer from "../../../Forms/TrialBadAnswer/TrialBadAnswer";
import AllCertificates from "../../../Forms/AllCertificates/AllCertificates";
import Buy from "../../../Forms/Buy/Buy";
import JustRegister from "../../../Forms/JustRegister/JustRegister";
import { YM_KEY, PROXY_URL } from "../../../../shared/constants";
import "./Button.css";

export default Button = (props) => {
	const {
		type,
		value,
		disabled = false,
		fields,
		setIsWaitingAnswer,
		method,
		validate,
		phoneFieldConfirmed,
		existsErrors,
		setAnswerText,
	} = props;


	const [_, setCookie] = useCookies(['PHPSESSID']);
	const {
		setUserProfile,
		userProfile,
		basketData,
		orderData,
		isCertificate,
		setIsCertificate,
		setShowTestDrive,
		setUserCanUseTrial,
		userCanUseTrial,
		setPreUserLogin,
		justBuyCertificate,
		isCourse,
		setUserStatus,
		typeOfProduct,
		setSelectedProduct,
	} = useUserContext();
	const {
		setActive,
		setContent,
		setNeedContinue,
		fromTrialPopup,
		setAnonymousCanGetTrial,
	} = usePopupContext();


	const login = () => {
		const { login, password } = fields;
		const errors = validateAuth(fields);
		validate(errors);

		const countErrors = Object.values(errors).filter((value) => value !== '').length;
		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}

		if (countErrors === 0) {
			setIsWaitingAnswer(true);
			const db = new BC365Service();
			db.login(login, password).then((answer) => {
				if (answer['is_authorized']) {
					setUserProfile({
						fio: `${answer['user_data']['name']}`,
						email: answer['user_data']['email'],
						avatar: answer['user_data']['photo'],
						login: answer['user_data']['login'],
						user_id: answer['user_data']['user_id'],
						token: answer.session_id,
						online: true,
					});
					setCookie('PHPSESSID', answer.session_id, { path: '/' });
					setUserStatus(2);
				} else {
					const errors = {
						be: 'Логин или пароль неправильные',
					};
					validate(errors);
					existsErrors(true);
					setUserStatus(1);
				}
				setIsWaitingAnswer(false);
			});
		}
	};

	const register = () => {
		const errors = validateRegister(fields);
		validate(errors);
		const { secondName, email, phone, password } = fields;
		const countErrors = Object.values(errors).filter((value) => value !== '').length;

		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}

		if (countErrors === 0) {
			setIsWaitingAnswer(true);
			const db = new BC365Service();
			const isConfirmedPhone = (phoneFieldConfirmed) ? 'Y' : 'N';
			db.register(secondName, email, phone, password, isConfirmedPhone).then((answer) => {
				if (answer['is_registered']) {
					ym(YM_KEY, 'reachGoal', 'lead_registration_buy');
					setUserProfile({
						fio: `${answer['user_data']['name']} ${answer['user_data']['last_name']}`,
						email: answer['user_data']['email'],
						avatar: answer['user_data']['photo'],
						login: answer['user_data']['login'],
						token: answer.session_id,
						user_id: answer['user_data']['user_id'],
						online: true,
					});
					setCookie('PHPSESSID', answer.session_id, { path: '/' });
					setUserStatus(2);
				} else {
					const errors = {
						be: answer['error'],
					};
					validate(errors);
					existsErrors(true);
					setUserStatus(1);
				}
				setIsWaitingAnswer(false);
			});
		}
	};

	const forgot = () => {
		const errors = validateRegister(fields);
		validate(errors);
		const { email } = fields;
		const countErrors = Object.values(errors).filter((value) => value !== '').length;

		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}
		if (countErrors === 0) {
			setIsWaitingAnswer(true);
			const db = new BC365Service();
			db.forgotPassword(email).then((answer) => {
				if (answer['error'] === '') {
					setAnswerText(answer['answer']);
				} else {
					const errors = {
						be: answer['error'],
					};
					validate(errors);
					existsErrors(true);
				}
				setIsWaitingAnswer(false);
			});
		}
	};

	const checkEmail = () => {
		const errors = validateRegister(fields);
		validate(errors);
		const { email } = fields;
		const countErrors = Object.values(errors).filter((value) => value !== '').length;

		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}
		if (countErrors === 0) {
			setPreUserLogin(email);
			setIsWaitingAnswer(true);
			const db = new BC365Service();
			db.existsByEmail(email).then((answer) => {
				if (answer['user_id'] > 0) {
					const userId = answer['user_id'];
					// only if coming from trial popup
					if (fromTrialPopup) {
					} else {
						existsErrors(false);
						setIsCertificate(false);
						setContent(<AllProducts />);
						setNeedContinue(true);
						setUserProfile({
							...userProfile,
							login: answer['user_login'],
							user_id: answer['user_id'],
							email: answer['email'],
							fio: answer['fio'],
						});
					}
					// hide get trial, just buy products
					/* db.canGetTrial().then((answer) => {
						const { result } = answer;
						setShowTestDrive(result);
						setUserCanUseTrial(result);
					}); */
					/* if (userCanUseTrial) {
						setContent(<WaitingTrialAnswer />);
						// add trial and redirect to personal area
						db.setTrial().then((answer) => {
							const { result } = answer;
							if (result) {
								window.location.assign('/personal/'); 
							}
						});
					} else { */

					/* } */
				} else {
					existsErrors(false);
					setContent(<JustRegister />);
					setNeedContinue(true);
					setIsWaitingAnswer(false);
				}
			});
		}
	};

	const widgetPayselection = (options) => {
		let widget = new pw.PayWidget();

		options.push({
			// Варианты ключей которые могут приходить по колбекам:
			// для onSuccess -> PAY_WIDGET:TRANSACTION_SUCCESS
			// для onError -> PAY_WIDGET:TRANSACTION_FAIL, PAY_WIDGET:CREATE_NETWORK_ERROR, PAY_WIDG:CREATE_BAD_REQUEST_ERROR
			onSuccess: function (res) {
				console.log("onSuccess from shop", res);
				//window.location.href = response.return_url;
			},
			onError: function (res) {
				console.log("onFail from shop");
				console.log(res);
				//window.location.href = response.return_url;
			},
			onClose: function (res) {
				console.log("onClose from shop", res);
			},
		}
		);

		widget.pay(
			options[0],
			options[1],
			options[2]
		);
	}

	const widgetPayinPayout = (options) => {
		let payinpayoutForm = document.getElementById("payinpayoutForm");
		if (payinpayoutForm !== null)
			payinpayoutForm.remove();

		let formData = JSON.parse(options);
		//console.log(formData);
		let form = document.createElement('form');
		form.id = 'payinpayoutForm';
		form.method = 'POST';
		form.action = formData.url;

		for (const name in formData) {
			if (name === 'url')
				continue;

			let input = document.createElement('input');
			input.type = 'hidden';
			input.value = formData[name];
			input.name = name;

			form.append(input);
		}

		document.body.append(form);

		form.submit();
	}

	const checkEmailCertificate = () => {
		const errors = validateRegister(fields);
		validate(errors);
		const { email } = fields;
		const countErrors = Object.values(errors).filter((value) => value !== '').length;

		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}
		if (countErrors === 0) {
			//console.log('checking email');
			setIsWaitingAnswer(true);
			const db = new BC365Service();
			db.existsByEmail(email).then((answer) => {
				if (answer['user_id'] > 0) {
					existsErrors(false);
					setIsCertificate(true);
					setContent(<AllCertificates />);
					setNeedContinue(true);
					setUserProfile({
						...userProfile,
						login: answer['user_login'],
						user_id: answer['user_id'],
						email: answer['email'],
						fio: answer['fio'],
					});
				} else {
					existsErrors(false);
					setContent(<JustRegister />);
					setNeedContinue(true);
					setIsWaitingAnswer(false);
				}
			});
		}
	};

	const registerAndBuy = () => {
		const errors = validateRegister(fields);
		validate(errors);
		const { name, secondName, email, phone, password, repeatPassword } = fields;
		const countErrors = Object.values(errors).filter((value) => value !== '').length;

		if (countErrors) {
			existsErrors(true);
		} else {
			existsErrors(false);
		}

		if (countErrors === 0) {
			if (!fromTrialPopup) {
				setIsWaitingAnswer(true);
			}
			const db = new BC365Service();
			const isConfirmedPhone = (phoneFieldConfirmed) ? 'Y' : 'N';
			db.register(name, secondName, email, phone, password, isConfirmedPhone).then((answer) => {
				if (answer['is_registered']) {
					if (!justBuyCertificate && answer['user_data']['user_id'] > 0) {
						const userId = answer['user_data']['user_id'];
						if (fromTrialPopup) {
						} else {
							setContent(<AllProducts />);
							setUserProfile({
								fio: `${answer['user_data']['name']} ${answer['user_data']['last_name']}`,
								email: answer['user_data']['email'],
								avatar: answer['user_data']['photo'],
								login: answer['user_data']['login'],
								user_id: answer['user_data']['user_id'],
								token: answer.session_id,
								online: true,
							});
						}
						/*setActive(true);
						setContent(<WaitingBeforeTrialAnswer />);
						const timer = setTimeout(() => {
							db.canGetTrial().then((answerTrial) => {
								ym(YM_KEY,'reachGoal','trial');
								console.log('answer: ', answer);
								console.log('answerTrial: ', answerTrial);
								const { result } = answerTrial;
								setShowTestDrive(result);
								setUserCanUseTrial(result);
	
								if (result) {
									setContent(<WaitingTrialAnswer />);
									// add trial and redirect to personal area
									db.setTrial().then((answerTrial) => {
										const { result } = answerTrial;
										if (result) {
											window.location.assign('/personal/'); 
										}
									});
								} else {
									setContent(<AllProducts />);
									setUserProfile({
										fio: `${answer['user_data']['name']} ${answer['user_data']['last_name']}`, 
										email: answer['user_data']['email'], 
										avatar: answer['user_data']['photo'], 
										login: answer['user_data']['login'], 
										user_id: answer['user_data']['user_id'], 
										token: answer.session_id, 
										online: true,
									});
								}
							});
							clearTimeout(timer);
						}, 50);*/
						// hide get and set trial. Just buy products

					} else {
						setContent(<AllCertificates />);
						setUserProfile({
							fio: `${answer['user_data']['name']} ${answer['user_data']['last_name']}`,
							email: answer['user_data']['email'],
							avatar: answer['user_data']['photo'],
							login: answer['user_data']['login'],
							user_id: answer['user_data']['user_id'],
							token: answer.session_id,
							online: true,
						});
					}
					setCookie('PHPSESSID', answer.session_id, { path: '/' });
				} else {
					const errors = {
						be: answer['error'],
					};
					validate(errors);
					existsErrors(true);
				}
				setIsWaitingAnswer(false);
			});
		}
	};

	const buy = () => {
		/*setActive(true);
		setContent(<Buy />);*/
		setSelectedProduct(true);
	};

	const processPaysystem = (paysystem, answer) => {
		if (['CLOUDPAYMENTS', 'CLOUDPAYMENTS_KZ'].includes(paysystem)) {
			const order = answer['res']['order'];
			// const return_url = answer['res']['return_url'];

			let cpOptions = {
				...orderData,
			};
			cpOptions.data['order'] = order;
			cpOptions.invoiceId = order;
			cpOptions.description = `Заказ №${order} ${cpOptions.accountId}`;

			const widget = new cp.CloudPayments();
			widget.pay('charge',
				cpOptions,
				{
					onSuccess: function (options) { // success
						//console.log(options);
					},
					onFail: function (reason, options) { // fail
						//console.log(options);

					},
					onComplete: function (paymentResult, options) {
						//console.log(options);
					}
				}
			);
		}

		if (paysystem === 'PAYSELECTION')
			widgetPayselection(answer['res']['options']);

		if (paysystem === 'PAYINPAYOUT')
			widgetPayinPayout(answer['res']['options']);

		if (['TINKOFF', 'TINKOFF_SBP', 'TINKOFF_INSTALLMENT_3', 'TINKOFF_DOLYAMI', 'SBERPAY', 'SBER_LOAN', 'PRODAMUS', 'PRODAMUS_BY', 'PRODAMUS_SELECT'].includes(paysystem)) {
			window.location.href = answer['res']['pay_url'];
		}
	}

	const finish = () => {
		setIsWaitingAnswer(true);
		const { user_id, fio, email, phone } = userProfile;
		const { product_id, type } = basketData;
		const { paysystem } = orderData;
		const db = new BC365Service();
		if (isCertificate) {
			//ym(YM_KEY,'reachGoal','ORDER_sert');
			db.createOrderCommon(user_id, Number(product_id), fio, email, phone, paysystem, 'certificate').then((answer) => {
				setActive(false);
				processPaysystem(paysystem, answer);
				setIsWaitingAnswer(false);
			});
		} else {
			//ym(YM_KEY,'reachGoal','ORDER');
			// Step 2. Sales funnel (start payment process)
			db.startPayment({
				first_name: fio,
				email,
				product_id,
			}).then((answer) => {
				//console.log(answer);
			});
			if (isCourse) {
				//const type = (typeOfProduct === 1) ? 'course' : 'marathon';
				db.createOrderCommon(user_id, Number(product_id), fio, email, phone, paysystem, type).then((answer) => {
					setActive(false);
					processPaysystem(paysystem, answer);
					setIsWaitingAnswer(false);
				});
			} else {
				/*console.log('isCourse: ', isCourse)
				console.log('user_id: ', user_id)
				console.log('product_id: ', product_id)
				console.log('fio: ', fio)
				console.log('email: ', email)
				console.log('phone: ', phone)
				console.log('paysystem: ', paysystem)
				console.log('type: ', type)*/

				db.createOrderCommon(user_id, Number(product_id), fio, email, phone, paysystem, 'marathon').then((answer) => {
					setActive(false);
					processPaysystem(paysystem, answer);
					setIsWaitingAnswer(false);
				});
			}
		}
	};

	let callback;
	if (method === 'login') {
		callback = login;
	}
	if (method === 'register') {
		callback = register;
	}
	if (method === 'forgot') {
		callback = forgot;
	}
	if (method === 'check-email') {
		callback = checkEmail;
	}
	if (method === 'check-email-certificate') {
		callback = checkEmailCertificate;
	}
	if (method === 'register-and-buy') {
		callback = registerAndBuy;
	}
	if (method === 'buy') {
		callback = buy;
	}
	if (method === 'finish') {
		callback = finish;
	}


	return (
		<input
			type={type}
			value={value}
			disabled={disabled}
			className={disabled ? "inputButton inputButtonDisabled" : "inputButton"}
			onClick={callback}


		/>
	);
}
